export default "__VITE_ASSET__DU5ipW2A__"